'use client';

import { c as _c } from "react/compiler-runtime";
import { TransitionStartFunction, useEffect } from 'react';
import { ArrowUndoIcon } from '@navikt/aksel-icons';
import { BodyShort } from '@navikt/ds-react';
import { setBreadcrumbs } from '@navikt/nav-dekoratoren-moduler';
import { hentArbeidsforhold } from '../_actions/hentArbeidsforhold';
import ResultatWrapper from '@/app/_components/ResultatWrapper';
import { store } from '@/app/_components/store/store';
import { LinkButton } from '@/components/link-button/LinkButton';
import { areaPath } from '@/urls';
export const Arbeidssted = t0 => {
  const $ = _c(24);
  const {
    startTransition
  } = t0;
  const {
    tekst,
    arbeidsgiver
  } = store.useReducerState();
  const {
    SET_ARBEIDSGIVER_VIEW,
    REQUEST_ARBEIDSGIVER_ARBEIDSFORHOLD,
    SET_ARBEIDSGIVER_ARBEIDSFORHOLD
  } = store.useActions();
  const {
    arbeidssted,
    arbeidsstedLoading
  } = arbeidsgiver;
  let t1;
  if ($[0] !== tekst._prefix || $[1] !== tekst.breadcrumbs.arbeidssted || $[2] !== tekst.landing.arbeidsgiver.heading) {
    t1 = () => {
      setBreadcrumbs([{
        title: tekst.landing.arbeidsgiver.heading,
        url: areaPath("arbeidsgiver", tekst._prefix),
        handleInApp: true
      }, {
        title: tekst.breadcrumbs.arbeidssted,
        url: areaPath("arbeidsgiver", tekst._prefix, "/arbeidssted"),
        handleInApp: true
      }]);
    };
    $[0] = tekst._prefix;
    $[1] = tekst.breadcrumbs.arbeidssted;
    $[2] = tekst.landing.arbeidsgiver.heading;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== tekst) {
    t2 = [tekst];
    $[4] = tekst;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== REQUEST_ARBEIDSGIVER_ARBEIDSFORHOLD || $[7] !== SET_ARBEIDSGIVER_ARBEIDSFORHOLD || $[8] !== SET_ARBEIDSGIVER_VIEW || $[9] !== startTransition) {
    t3 = uuid => {
      SET_ARBEIDSGIVER_VIEW("arbeidsforhold");
      REQUEST_ARBEIDSGIVER_ARBEIDSFORHOLD();
      startTransition(async () => {
        SET_ARBEIDSGIVER_ARBEIDSFORHOLD(await hentArbeidsforhold(uuid));
      });
    };
    $[6] = REQUEST_ARBEIDSGIVER_ARBEIDSFORHOLD;
    $[7] = SET_ARBEIDSGIVER_ARBEIDSFORHOLD;
    $[8] = SET_ARBEIDSGIVER_VIEW;
    $[9] = startTransition;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const onNavigateToArbeidsforhold = t3;
  let t4;
  if ($[11] !== SET_ARBEIDSGIVER_VIEW) {
    t4 = () => SET_ARBEIDSGIVER_VIEW("hovedenhet");
    $[11] = SET_ARBEIDSGIVER_VIEW;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ArrowUndoIcon aria-hidden={true} />;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== tekst.knapp.tilbake) {
    t6 = <BodyShort spacing={true}><LinkButton onClick={t4}>{t5}{tekst.knapp.tilbake}</LinkButton></BodyShort>;
    $[14] = t4;
    $[15] = tekst.knapp.tilbake;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== arbeidssted || $[18] !== arbeidsstedLoading || $[19] !== onNavigateToArbeidsforhold) {
    t7 = <ResultatWrapper loading={arbeidsstedLoading} data={arbeidssted} type="arbeidssted" onNavigateToArbeidsforhold={onNavigateToArbeidsforhold} />;
    $[17] = arbeidssted;
    $[18] = arbeidsstedLoading;
    $[19] = onNavigateToArbeidsforhold;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t6 || $[22] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default Arbeidssted;